import { NumberField } from 'enova-frontend-components';
import { Control, Controller } from 'react-hook-form';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AboutFormData } from '../../types';
import { useAboutFormContext } from '../../utils';

interface Props {
  control: Control<AboutFormData>;
}

export const HeatedAreaField: FC<Props> = ({ control }) => {
  const { t } = useTranslation();
  const { trigger } = useAboutFormContext();
  return (
    <Controller
      control={control}
      name="bygginfo.heatedArea"
      rules={{
        validate: (value, formValues) => {
          // Oppvarmet BRA is required
          if (!value || value === 0) {
            return t('register.errorMessage.field.totalOppvarmetBRA');
          }

          const totalArea = formValues.bygginfo?.area;

          // Oppvarmet BRA must be less than or equal to total BRA
          if (!!totalArea && Number(value) > Number(totalArea)) {
            return t('register.errorMessage.field.totalOppvarmetBRA_custom');
          }
        }
      }}
      render={({ field, fieldState: { error }, formState }) => {
        return (
          <NumberField
            required
            suffix={t('suffix.m2')}
            error={!!error}
            helperText={error && t(`${error.message}`)}
            value={field.value}
            onValueChange={({ floatValue }) => {
              field.onChange(floatValue || null);

              if (formState.isSubmitted) {
                trigger('bygginfo.area');
              }
            }}
            label={t('register.bygningsdetaljer.totalOppvarmetBRA.label')}
            HelperBoxProps={{
              'aria-label': t('readFieldInformation'),
              children: t('register.bygningsdetaljer.totalOppvarmetBRA.information')
            }}
          />
        );
      }}
    />
  );
};
